import { render, staticRenderFns } from "./IconMailOpenSolid.vue?vue&type=template&id=533525d5"
import script from "./IconMailOpenSolid.vue?vue&type=script&lang=js"
export * from "./IconMailOpenSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports